export default "__VITE_ASSET__DM_kw$ju__"